module.exports = __webpack_public_path__ + "img/swiper-left-btn2.940c5c53.svg";